export default "__VITE_ASSET__Djp7f_1m__"